import { render, staticRenderFns } from "./statementManagementFinance.vue?vue&type=template&id=fecb03aa&scoped=true"
import script from "./statementManagementFinance.vue?vue&type=script&lang=js"
export * from "./statementManagementFinance.vue?vue&type=script&lang=js"
import style0 from "./statementManagementFinance.vue?vue&type=style&index=0&id=fecb03aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecb03aa",
  null
  
)

export default component.exports